import { Injectable } from '@angular/core';
import { ViewportRuler as CdkViewportRuler  } from '@angular/cdk/scrolling';

@Injectable({ providedIn: 'root' })
export class ViewportRuler extends CdkViewportRuler {

  constructor() {
    super();
  }
}
